import {map, pipe, range, reverse} from 'ramda';

import {Nullish} from 'shared/web';

import {MIN_FIRST_REGISTRATION_YEAR} from '../pages/Create/constants/minFirstRegistrationYear';
import {filterByMinMax} from './filterByMinMax';

const YEAR_VALUES = range(MIN_FIRST_REGISTRATION_YEAR, new Date().getFullYear() + 1);

export const getYearOptions = (min?: number | Nullish, max?: number | Nullish) =>
  pipe(
    filterByMinMax(min, max),
    reverse,
    map((value: number) => ({label: `${value}`, value}))
  )(YEAR_VALUES);
